import { render, staticRenderFns } from "./product-resource-1.vue?vue&type=template&id=6b8add3c&"
import script from "./product-resource-1.vue?vue&type=script&lang=ts&"
export * from "./product-resource-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports